export const sud = {
  root_old: '10px',
  root: '10px',
} as const;
